import api from '@/api';
import eventBus from '@/utils/eventBus';

export const ProductRule = {
  data () {
    return {
      productRuleList: [],
      productCodeList: []
    };
  },
  methods: {
    getWeakCorrelation (productCode, purchaseQuantity) {
      if (purchaseQuantity == 0) {
        // let productList = this.productRuleList.filter((p) => p.productcode != productCode);
        this.productCodeList = this.productCodeList.filter((p) => p != productCode);
        this.productRuleList = this.productRuleList.filter((p) => p.productcode != productCode); ;
        return;
      }
      let product = this.productCodeList.filter((p) => p == productCode);
      if (product.length == 0) {
        this.productCodeList.push(productCode);
        api.getWeakCorrelation({ params: { 'productCode': productCode } }).then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data != null) {
            this.productRuleList.push(json.data);
          }
        }).catch((e) => {
          console.log(e);
          this.$notify.error('网络异常');
        });
      }
    },

    getHostValidate (subId) {
      let that = this;
      api.getHostValidate({ params: { 'subId': subId } }).then((res) => {
        let json = res.data;
        if (json.status === '200' && json.data != null) {
          this.productRuleList = json.data;
          this.productRuleList.forEach(function (item, index) {
            that.productCodeList.push(item.productcode);
          });
        }
      }).catch((e) => {
        console.log(e);
        this.$notify.error('网络异常');
      });
    }
  }
};
